/**
 * Light styles to try (the user, 11 Oct: "add them all, until I get a good chance
 * to use them, then we'll decide"). Crisp is the default; the others are Olivia's
 * rounds (styles/light-styles.css) and the light before Crisp
 * (styles/light-legacy.css). Chosen in Settings → Appearance or with
 * ?light=<name>, and remembered in this browser. Light only.
 */
export const LIGHT_STYLES = [
  { name: "crisp", label: "Crisp", note: "borders on white (default)" },
  { name: "ledger", label: "Ledger", note: "boxed panels, firmest lines (Olivia's pick)" },
  { name: "graphite", label: "Graphite", note: "light grey chrome around white" },
  { name: "contrast", label: "Contrast", note: "near-monochrome, whitespace" },
  { name: "shelf", label: "Shelf", note: "white, with a pale blue sidebar" },
  { name: "studio", label: "Studio", note: "Crisp with a deeper canvas" },
  { name: "paper", label: "Paper", note: "warm greys" },
  { name: "legacy", label: "Before Crisp", note: "the light until 11 Oct" },
] as const;

export type LightStyle = (typeof LIGHT_STYLES)[number]["name"];

const KEY = "lilia.light";
const NAMES = new Set<string>(LIGHT_STYLES.map((s) => s.name));

export function currentLightStyle(): LightStyle {
  try {
    const v = localStorage.getItem(KEY);
    return v && NAMES.has(v) ? (v as LightStyle) : "crisp";
  } catch {
    return "crisp";
  }
}

function apply(style: LightStyle): void {
  if (style === "crisp") document.documentElement.removeAttribute("data-light");
  else document.documentElement.setAttribute("data-light", style);
}

export function setLightStyle(style: LightStyle): void {
  try {
    if (style === "crisp") localStorage.removeItem(KEY);
    else localStorage.setItem(KEY, style);
  } catch {
    // Not kept: this page only.
  }
  apply(style);
}

/** At start: ?light=<name> chooses (and is remembered); otherwise the remembered one. */
export function applyLightStyleAtStart(): void {
  try {
    const q = new URLSearchParams(window.location.search).get("light");
    if (q && NAMES.has(q)) {
      setLightStyle(q as LightStyle);
      return;
    }
  } catch {
    // Fall through to what is remembered.
  }
  apply(currentLightStyle());
}
